import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { PropertyStickyBookBar } from '@shared-ui/lodging-property-offers';

import { CurrentHotelStore } from 'stores/current-hotel-store';
import { MultiItemStore } from 'stores/multi-item-store';

import { SharedUiWrapperProps, withSharedUiPropertyOffers } from './shared-ui-property-offers';
import { SingleOfferSearchForm } from '../../single-offer-search';

interface SharedUiPropertyStickyBookBarProps extends SharedUiWrapperProps {
  currentHotel?: CurrentHotelStore;
  multiItem?: MultiItemStore;
}

export const StickyBookBarWrapper: React.FC<SharedUiPropertyStickyBookBarProps> = inject(
  'currentHotel',
  'multiItem'
)(
  observer(({ inputs, multiItem }) => {
    // Used for H+H use case
    if (multiItem?.cartInfo?.id) {
      return null;
    }

    return (
      <PropertyStickyBookBar inputs={inputs} focusTargetRef="Offers" skipSsr={true}>
        <SingleOfferSearchForm />
      </PropertyStickyBookBar>
    );
  })
);

StickyBookBarWrapper.displayName = 'StickyBookBarWrapper';

export const SharedUiStickyBookBarWrapper = withSharedUiPropertyOffers(StickyBookBarWrapper);
